export const blockIconsSocialPersonAddAlt = (
	<span className='material-symbols-outlined'>person_add_alt</span>
);
